const $figureModal = $(".figure-modal");


$figureModal.each((_, el) => {
  const $el = $(el);

  $el.find('.close').on('click', function () {

    var youtubeEl = $el.find('iframe[src*="youtube"]');

    // if iframe with video exists
    if (youtubeEl.length > 0) {
      // store src of element
      var src = youtubeEl.attr('src');

      // empty the iframe's src attribute
      youtubeEl.attr('src', '');

      // Again ready to be played
      youtubeEl.attr('src', src);
    }
  });
});
